<bdo-tariff-advisor
  [trackingLocation]="trackingLocation"
  [processContext]="'CONTRACT_NEW'"
></bdo-tariff-advisor>
